import React, { useState, useEffect, useRef } from 'react';
import ProfileRow from './ProfileRow';
import CanvasItem from './avwapp.chart';
import { fetchData } from './service/avwapp.service';
import { host } from './env';
import StockPopupButton from './StockPopupButton';

type RspProps = {};

export type Rsp = {
  symbol: string;
  calculatedAt: string
  prevRs: number;
  latestRs: number;
  percentIncrease: number;

};

const Rsp: React.FC<RspProps> = ({}) => {
  const [rspData, setRspData] = useState<Rsp[]>(
    [],
  );
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    handleRsp();
  }, []);

  const fetchRspFromApi = async () => {
    try {
      const result = await fetchData(`${host}/rsPerformance`);
      setRspData(result);
    } catch (err) {
      setError('Failed to get rsp stocks');
      console.log('err', err);
    } finally {
    }
  };

  const handleRsp = async () => {
    fetchRspFromApi();
  };

  function formatMarketCap(value: number): string {
    if (value >= 1_000_000_000) {
      return (value / 1_000_000_000).toFixed(2) + 'B';
    } else if (value >= 1_000_000) {
      return (value / 1_000_000).toFixed(2) + 'M';
    } else if (value >= 1_000) {
      return (value / 1_000).toFixed(2) + 'K';
    } else {
      return value.toString();
    }
  }

  function formatPercentage(decimal: number): string {
    return (decimal * 100).toFixed(1) + '%';
  }

  return (
    <div>
      <h3 className="avwapp-subtitle">
        Notable Relative Performance Increases
      </h3>
      <table className="qualityStocks">
        <thead>
          <tr>
            <td>Symbol</td>
            <td>Calculated At</td>
            <td>Previous RS</td>
            <td>Latest RS</td>
            <td>Percent Increase</td>
          </tr>
        </thead>

        {rspData.map((item: Rsp) => (
          <tr>
            <td>{<StockPopupButton symbol={item.symbol} />}</td>
            <td>{item.calculatedAt} </td>
            <td>{item.prevRs} </td>
            <td>{item.latestRs} </td>
            <td>{item.percentIncrease} </td>
          </tr>
        ))}
      </table>
    </div>
  );
};

export default Rsp;
